import { forwardRef } from 'react';

import { useSelectEquipment } from '@/features/equipment-browser/equipment-details/hooks/use-select-equipment';
import { useJumpToEquipment } from '@/features/equipment-browser/equipment-details/page-header/useJumpToEquipment';
import { Button, ButtonProps } from '@/ux-common/components/button/button';

interface JumpToEquipmentButtonProps extends ButtonProps {
  equipmentId: string | undefined;
}

export const JumpToEquipmentButton = forwardRef<HTMLButtonElement, JumpToEquipmentButtonProps>(
  ({ equipmentId, children, ...props }, ref) => {
    const { selectEquipmentAction } = useSelectEquipment();
    const { sections } = useJumpToEquipment();

    if (!equipmentId) return null;

    return (
      <Button
        ref={ref}
        onClick={() => {
          selectEquipmentAction(
            equipmentId,
            sections?.find((section) => section.order.includes(equipmentId))?.id || ''
          );
        }}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

JumpToEquipmentButton.displayName = 'JumpToEquipmentButton';
